<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<h2
    class="my-4"
    i18n
>Select the scope</h2>
<app-loading-spinner [loadable$]="validatedCategories$"></app-loading-spinner>
<app-error-state [loadable$]="validatedCategories$"></app-error-state>
<app-radio-select
    *ngIf="validatedCategories$ | async as categories"
    name="scopes"
    i18n-name
    [selected]="selectedScopeCategory$ | async"
    [options]="categories"
    (selectOption)="selectCategory($event)"
></app-radio-select>

<ng-container *ngIf="useProjectCommitteeHandler">
    <app-project-committee-handler
        [usernames]="usernames"
        [roleId]="roleId"
        (saved)="onSaved($event)"
    >
    </app-project-committee-handler>
</ng-container>


<ng-container *ngIf="!useProjectCommitteeHandler">
    <div #scopeCatRef>
        <h5
            class="mt-4"
            i18n
        >Select Scope Names</h5>
        <div
            #multiSelectRef
            class="custom-control custom-radio mb-3 mr-4 disp-inlineblk"
        >
            <input
                #radioBtnSelectMultipleRef
                name="rdoScopeSelection"
                class="custom-control-input"
                id="rdoMultiple"
                (change)="onSelectMultiple($event, scopeCategoryRef)"
                type="radio"
                checked
            />
            <label
                class="custom-control-label"
                for="rdoMultiple"
            >Select Multiple</label>
        </div>
        <div
            #selectAllRef
            class="custom-control custom-radio mb-3 mr-4 disp-inlineblk"
        >
            <input
                name="rdoScopeSelection"
                class="custom-control-input"
                id="rdoSelectAll"
                (change)="onSelectAll($event, scopeCategoryRef)"
                type="radio"
            />
            <label
                class="custom-control-label"
                for="rdoSelectAll"
            >Select All</label>
        </div>
        <div #scopeCategoryRef>
            <app-data-table-ajax
                #dataTableAjax
                url="/roles/scopes/{{ categoryId }}"
                limit="5"
                [columns]="columns"
                [excludedItems]="userProjectScope$ | async"
                selectionType="multiClick"
                (rowClicked)="onSelectConstraints($event)"
            >
            </app-data-table-ajax>
            <div #scopeMultipleRef>
                <h5
                    class="mt-4 font-weight-bold"
                    i18n
                >Select Organizations</h5>
                <app-data-table-ajax
                    #dataTableAjaxMultiScope
                    url="/roles/scopes/2"
                    limit="5"
                    [columns]="columns"
                    selectionType="multiClick"
                    (rowClicked)="onSelectMultipleConstraints($event)"
                >
                </app-data-table-ajax>
            </div>
        </div>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-scope-options/role-scope-options.component.html